import Vue from 'vue'
// import DatePicker from './date-picker/index'
// Vue.use(DatePicker);
// element按需引入  引入插件
import {
  Pagination, // 分页
  Loading, // 加载
  Message, // 弹框
  Menu, // 头部导航
  MenuItem, // 头部导航
  Submenu, // 头部导航
  Breadcrumb, // 面包屑
  BreadcrumbItem, // 面包屑
  Tabs, // 标签页
  TabPane, // 标签页
  Container, // 页面布局
  Header, // 页面布局
  Main, // 页面布局
  Footer, // 页面布局
  Input, // 输入框
  FormItem, // 表单元素
  Form, // 表单元素
  Col, // 表单元素
  Select, // 表单元素
  Option, // 表单元素
  DatePicker, // 时间元素
  Button, // 按钮
  TableColumn, // 表格元素
  Row,
  Table,
  Collapse,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  MessageBox, // 弹框
  Dialog, // 弹框
  Transfer, // 穿梭狂
  Avatar,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Popover, // 消息提示
  Radio,
  Upload, // 文件上传,
  Tree,
  RadioGroup, // 单选
  ButtonGroup, // 单选
  Tag,
  InputNumber,
  Switch,
  Autocomplete // 输入建议
} from 'element-ui'
// // 初始化插件
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Col)
Vue.use(Form)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Button)
Vue.use(TableColumn)
Vue.use(Row)
Vue.use(Table)
Vue.use(Collapse)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Transfer)
Vue.use(Avatar)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(Upload)
Vue.use(Tree)
Vue.use(RadioGroup)
Vue.use(Tag)
Vue.use(ButtonGroup)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Autocomplete)

// Vue.use(Loading.directive);
// // // 挂载插件
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm

// 弹框的方法Vue.prototype.$confirm = MessageBox.confirm;
//     MsgSuccess(title,type) {
// Message({
//     showClose: true,
//     message: title,
//     type: type,
//     duration:1000
// });
//     },

let messageInstance = null
const resetMessage = (options, status = true) => {
  if (status) {
    if (messageInstance) {
      messageInstance.close()
    }
  }
  messageInstance = Message({
    showClose: false,
    message: options.message,
    type: options.type,
    duration: 1500
  })
};
['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = (options, status) => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return resetMessage(options, status)
  }
})
export const message = resetMessage

Vue.prototype.openLoading = function () {
  const loading = Loading({ // 声明一个loading对象
    lock: true, // 是否锁屏
    text: '正在加载...', // 加载动画的文字
    spinner: 'el-icon-loading', // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.3)', // 背景颜色
    target: '.sub-main', // 需要遮罩的区域
    body: true,
    customClass: 'mask' // 遮罩层新增类名
  })
  setTimeout(function () { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close() // 关闭遮罩层
  }, 5000)
  return loading
}
